/**
 * @desc Names of the reducers in the store.
 * @example
 * import { REDUCER } from 'constants/entity-names';
 * console.log( REDUCER.APP_CONTEXT );
 */
export const REDUCER = {
	APP_CONTEXT: 'APP_CONTEXT',
	USER_SESSION: 'USER_SESSION',
	URLS: 'URLS',
	LABELS: 'LABELS',
	COMPONENT_DATA: 'COMPONENT_DATA',
	CALL_STATE: 'CALL_STATE',
	CHECKOUT_STATE: 'CHECKOUT_STATE',
	MEMBER_VERIFICATION_STATE: 'MEMBER_VERIFICATION_STATE',
	MEMBER_MANAGEMENT_STATE: 'MEMBER_MANAGEMENT_STATE'
};

/**
 * @desc Component names whose response will be cached in the Redux store.
 * @example
 * import { COMPONENT_NAMES } from 'constants/entity-names';
 */
export const COMPONENT_NAMES = {
	SITE_HEADER: 'SITE_HEADER',
	SITE_FOOTER: 'SITE_FOOTER',
};

/**
 * @desc Names of the widgets in the application.
 * @example
 * import { WIDGET_NAMES } from 'constants/entity-names';
 */
export const WIDGET_NAMES = {

	// dashboard widgets
	CALL_CONTROL: 'callControl',
	OFF_CALL_CONTROL: 'offCallControl',
	CALL_MANAGEMENT_LISTS: 'callManagementLists',
	CALL_AUTHORIZATION_FLOW: 'callAuthorizationFlow',
	MEMBER_MANAGEMENT: 'memberManagement',
	CALL_DETAIL: 'callItemDetail',

	/**-------*/

	CALL_DETAIL_SUMMARY: 'callItemDetailSummary',
	CALL_DETAIL_TABS: 'callItemDetailInnerTab',
	CALL_DETAIL_TABS_INNER_WIDGET: 'callItemDetailInnerWidget',
	CALL_DETAIL_TABS_INNER_WIDGET_CATEGORY_REASON: 'callWidgetCategoryReason',
	CALL_ITEM_NOTES: 'callItemNotes',
	CALL_DETAIL_TABS_INNER_WIDGET_ACTIVITY: 'callWidgetActivity',

	/*-------*/

	// call-management-list widgets
	MEMBER_SEARCH: 'memberSearch',
	CALL_LIST: 'callList',
	ACTION_LIST: 'actionList',
	TRANSFER_QUEUE: 'transferQueue',
	TO_DO_LIST: 'toDoList',

	/*---------------*/
	ACTION_DETAIL: 'actionItemDetail',
	ACTION_DETAIL_SUMMARY: 'actionItemDetailSummary',
	ACTION_DETAIL_TABS: 'actionItemDetailInnerTab',
	ACTION_DETAIL_TABS_INNER_WIDGET: 'actionItemDetailInnerWidget',
	ACTION_DETAIL_TABS_INNER_WIDGET_ACTIVITY: 'actionWidgetActivity',
	ACTION_DETAIL_TABS_INNER_WIDGET_NOTES: 'actionWidgetNotes',

	/*-------*/

	// call-disposition widgets
	CALL_DISPOSITION_REASONS: 'callDispositionReasons',
	CALL_DISPOSITION_ACTIVITY: 'callDispositionActivity',
	CALL_DISPOSITION_NOTES: 'callDispositionNotes',

	/*-------*/

	OFF_CALL_DISPOSITION_ACTIVITY: 'offCallDispositionActivity',
	OFF_CALL_DISPOSITION_NOTES: 'offCallDispositionNotes',

	/*-------*/

	// call-authorization widgets
	AUTH_FLOW_CALLER_IDENTIFICATION: 'authFlowCallerIdentification',
	AUTH_FLOW_CALLER_IDENTIFICATION_MEMBER: 'authFlowCallerIdentificationMember',
	AUTH_FLOW_CALLER_IDENTIFICATION_PHARMACY: 'authFlowCallerIdentificationPharmacy',
	AUTH_FLOW_CALLER_IDENTIFICATION_CLIENT: 'authFlowCallerIdentificationClient',
	AUTH_FLOW_CALLER_IDENTIFICATION_DOCTOR: 'authFlowCallerIdentificationDoctor',
	AUTH_FLOW_CALLER_IDENTIFICATION_OTHERS: 'authFlowCallerIdentificationOthers',
	AUTH_FLOW_CALLER_IDENTIFICATION_THIRD_PARTY: 'authFlowCallerIdentificationThirdParty',

	AUTH_FLOW_MEMBER_VERIFICATION: 'authFlowMemberVerification',
	AUTH_FLOW_MEMBER_VERIFICATION_MEMBER_SEARCH: 'authFlowMemberVerificationMemberSearch',
	AUTH_FLOW_MEMBER_VERIFICATION_MATCH_CRITERIA: 'authFlowMemberVerificationMatchCriteria',
	AUTH_FLOW_MEMBER_VERIFICATION_FAMILY_UNIT: 'authFlowMemberVerificationFamilyUnit',
	AUTH_FLOW_MEMBER_VERIFICATION_HIPAA_AUTH: 'authFlowMemberVerificationHipaaAuth',
	AUTH_FLOW_MEMBER_VERIFICATION_COMM_HISTORY: 'authFlowMemberVerificationCommHistory',
	AUTH_FLOW_MEMBER_VERIFICATION_MEMBER_PRE_VERIFIED_MEMBERS: 'authFlowMemberVerificationPreVerifiedMembers',

	/*-------*/

	// member management widgets
	MEMBER_DETAILS_HEADER: 'memberDetailsHeader',
	MEMBER_DETAILS_QUICK_ACTIONS: 'memberDetailsQuickActions',
	MEMBER_DETAILS_ENTITIES: 'memberDetailsEntities',
	MEMBER_DETAILS_ELIGIBILITY: 'memberDetailsEligibility',
	MEMBER_DETAILS_ASSISTIVE_ACTIONS_NAV: 'memberDetailsAssistiveActionsNav',
	MEMBER_INFO_SETTINGS: 'memberInfoSettings',
	MEMBER_HEALTH_INFO: 'memberHealthInfo',
	MEMBER_DETAILS_COMMUNICATION_HISTORY: 'memberDetailsCommunicationHistory',
	MEMBER_DETAILS_ELIGIBILITY_HISTORY: 'memberEligibilityHistory',

	// member management header widgets
	MEMBER_DETAILS_HEADER_FAMILY_UNIT: 'memberDetailsHeaderFamilyUnit',
	MEMBER_DETAILS_PAY_BALANCE: 'memberDetailsPayBalance',
	MEMBER_DETAILS_SAVINGS: 'memberDetailsSavings',
	MEMBER_DETAILS_SAVINGS_MAIL_PRESCRIPTION: 'memberDetailsSavingsMailPrescription',
	MEMBER_DETAILS_SAVINGS_RETAIL_PRESCRIPTION: 'memberDetailsSavingsRetailPrescription',
	MEMBER_DETAILS_ALERTS_STATS: 'memberDetailsAlertsStats',

	/*------*/

	// member entity details widgets

	MEMBER_DETAILS_ENTITIES_CLAIMS: 'memberDetailsEntitiesClaims',
	MEMBER_DETAILS_ENTITIES_PRESCRIPTION: 'memberDetailsEntitiesPrescriptions',
	MEMBER_DETAILS_ENTITIES_ORDERS: 'memberDetailsEntitiesOrders',
	MEMBER_DETAILS_ENTITIES_AR: 'memberDetailsEntitiesAR',
	MEMBER_DETAILS_ENTITIES_PRIOR_AUTHORIZATION: 'memberDetailsEntitiesPriorAuthorizations',

	// Member info settings widgets
	MEMBER_INFO_SETTINGS_COMMUNICATION_SETTINGS: 'memberInfoCommunicationSettings',
	MEMBER_INFO_SETTINGS_SHIPING_INFO: 'memberInfoShippingInfo',
	MEMBER_INFO_SETTINGS_PAYMENT_INFO: 'memberInfoPaymentInfo',

	// Member health Info
	MEMBER_INFO_SECURITY_INFO_SETTINGS: 'memberInfoSecuritySettings',
	MEMBER_ALLERGIES_INFO: 'memberAllergies',
	MEMBER_HEALTH_CONDITIONS: 'memberHealthConditions',

	// member entity detail view widgets
	ORDER_DETAILS: 'orderDetails',
	ORDER_DETAILS_SUMMARY: 'orderDetailsSummary',
	ORDER_DETAILS_RX: 'orderDetailsRx',
	CLAIM_DETAILS: 'claimDetails',
	PRESCRIPTION_DETAILS: 'prescriptionDetails',
	PRESCRIPTION_DETAILS_SUMMARY: 'prescriptionDetailsSummary',
	PRESCRIPTION_DETAILS_REFILLS: 'prescriptionDetailsRefills',
	PRESCRIPTION_DETAILS_CLAIMS: 'prescriptionDetailsClaims',
	CLAIM_DETAILS_SUMMARY: 'claimDetailsSummary',
	CSR_ORDER_NOTES_LINE: 'lineItem',
	CSR_ORDER_NOTES_LOG: 'workflowLog',
	CSR_ORDER_NOTES_ITEM: 'workflowItem',
	PRIOR_AUTH_DETAILS: 'priorAuthorizationsDetails',
	PRIOR_AUTH_SUMMARY: 'priorAuthorizationsDetailsSummary',

	// //member details pay balance widgets
	// MEMBER_DETAILS_PAY_BALANCE_STEPS: 'memberDetailsPayBalanceSteps',
	// MEMBER_DETAILS_PAY_BALANCE_SET_AMOUNT: 'memberDetailsPayBalanceSetAmount',
	// MEMBER_DETAILS_PAY_BALANCE_SELECT_CARD: 'memberDetailsPayBalanceSelectCard',

	/*------*/

	// checkout process paths
	CHECKOUT_NEW_ORDER: 'checkoutNewOrder',
	CHECKOUT_RE_ORDER: 'checkoutReOrder',
	CHECKOUT_EDIT_ORDER: 'checkoutEditOrder',
	CHECKOUT_SHIPPING_STEP_SAVED_ADDRESS: 'checkoutShippingStepSavedAddresses',
	CHECKOUT_SHIPPING_STEP_SHIPPING_OPTIONS: 'checkoutShippingStepShippingOptions',
	CHECKOUT_SHIPPING_STEP_COST_INFORMATION: 'checkoutShippingStepCostInformation',
	CHECKOUT_SHIPPING_STEP_PAYMENT_OPTIONS: 'checkoutShippingStepPaymentOptions',
	CHECKOUT_SHIPPING_STEP_ASSIGNING_COVERAGE: 'checkoutShippingStepAssigningCoverage',

	PRESCRIPTION_INFO: 'prescriptionInfo',
	SHIPPING_AND_PAYMENT_INFO: 'shippingAndPaymentInfo',
	CONFIRM_ORDER: 'confirmOrder',

	/*------*/

	// drug search (drug pricing and trial claims)
	DRUG_SEARCH: 'drugSearch',
	DRUG_PRICING_DRUG_SEARCH: 'drugPricingDrugSearch',
	DRUG_PRICING_DRUG_DETAIL: 'drugPricingDrugDetail',
	DRUG_PRICING_PHARMACY_LOCATOR: 'drugPricingPharmacyLocator',

	// member details communication history
	MEMBER_DETAILS_COMMUNICATION_HISTORY_CONTACT_LOG: 'memberDetailsCommunicationHistoryContactLog',
	MEMBER_DETAILS_COMMUNICATION_HISTORY_CALL_LOG: 'memberDetailsCommunicationHistoryCallLog',
	MEMBER_DETAILS_COMMUNICATION_HISTORY_ACTION_LOG: 'memberDetailsCommunicationHistoryActionLog',
	MEMBER_DETAILS_COMMUNICATION_HISTORY_TO_DOS: 'memberDetailsCommunicationHistoryToDos',


	// enroll to eposT
	ENROLL_TO_EPOST: 'enrollToEpost',
	REACTIVATE_EPOST: 'reactivateEpost',
	INSURANCE_INFORMATION: 'insuranceInformation',
	ALLERGIES_HEALTH_CONDITION: 'allergiesAndHealthConditions',
	PAYMENT_INFORMATION: 'paymentInformation',

	EPOST_CSR_MEMBER: 'ePostNotes',
	REACTIVATE_EPOST_INSURANCE_INFORMATION: 'reactivateEpostInsuranceInformation',

	// pay balance
	PAY_BALANCE: 'payBalance',
	PAY_BALANCE_SET_AMOUNT: 'payBalanceSetAmount',
	PAY_BALANCE_PAYMENT_OPTIONS: 'payBalancePaymentOptions',

	/* -------------- */

	// Reports
	REPORTS_STATISTICS: 'widgetStatisticsReport',
	REPORTS_TRENDS: 'widgetTrendsReport',
	CALL_STATISTICS_REPORTS: 'widgetCallsReport',
	CALL_RESOLUTIONS_REPORTS: 'widgetResolutionReport',
	CALL_TRENDS_DURATION_REPORTS: 'widgetDurationReport',

	/* -------------- */

	// Administration
	WELL_VIEW_ADMINISTRATION: 'widgetWellView',
	WELL_SERVE_ADMINISTRATION: 'widgetWellServ',

	// todo-detail widgets
	TO_DO_DETAIL: 'toDoDetail',
	TO_DO_DETAIL_SUMMARY: 'toDoItemSummary',
	TO_DO_DETAIL_ACTIVITY: 'toDoItemActivity',

	// Enable auto refill widget
	ENABLE_AUTO_REFILL: 'enableAutoRefill',

	// Communication settings
	MEMBER_INFO_SETTINGS_COMMUNICATION_SETTINGS_PHONE: 'memberInfoCommunicationSettingsPhone',
	MEMBER_INFO_SETTINGS_COMMUNICATION_SETTINGS_EMAIL: 'memberInfoCommunicationSettingsEmail',
	MEMBER_INFO_SETTINGS_COMMUNICATION_SETTINGS_WELLCONNECT: 'memberInfoCommunicationSettingsWellConnect',

	// Communication settings Address tab
	MEMBER_INFO_SETTINGS_SHIPPING_ADDRESS: 'memberInfoShippingAddress',
	MEMBER_INFO_SETTINGS_BILLING_ADDRESS: 'memberInfoBillingAddress',

	// Member alerts listing widget
	MEMBER_ALERTS_LISTING: 'memberAlertsListing',

	//sso-logout	
	SSO_LOGOUT_CONTAINER: 'SsoLogoutContainer'
};

export const MEMBER_SEARCH_MODULE = {
	DASHBOARD: 'dashboard',
	CALLER_IDENTIFICATION: 'callerIdentification',
	CALLEE_IDENTIFICATION: 'calleeIdentification'
};

export const MEMBER_SEARCH_VERIFICATION_MODULE = {
	DASHBOARD: 'dashboard',
	CALLER_VERIFICATION: 'callerVerification',
	CALLEE_VERIFICATION: 'calleeVerification'
};

export const CALL_TYPE = {
	INBOUND: 'inbound',
	OUTBOUND: 'outbound'
};

export const CREDIT_CARD_TYPE = {
	CREDIT_VISA: 'CREDIT VISA',
	MASTER_CARD: 'CREDIT MASTER CARD',
	DISCOVER: 'DISCOVER',
	AMERICAN_EXPRESS: 'AMERICAN EXPRESS',
	DEBIT_VISA: 'DEBIT VISA',
	DEBIT_MASTER_CARD: 'DEBIT MASTER CARD'
};
